var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-success"] || "oc-icon-status-success"), d: "M20 9.06a10 10 0 1 0-3 8.06L18.68 20 25 9.06zM8.78 15.39a.55.55 0 0 1-.62.11.57.57 0 0 1-.16-.13l-4.36-4.31a.54.54 0 0 1 0-.78l1.05-1a.54.54 0 0 1 .78 0l2.89 2.89L14.52 6a.53.53 0 0 1 .77 0l1.07 1a.54.54 0 0 1 0 .78zm9.88.9l-3.17-5.49h6.34z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/ConfirmedSub.svg